var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc flex column"},[_c('div',{staticClass:"flex-item chart-title"},[_vm._v(_vm._s(_vm.timeRangeText)+"服务类别统计")]),_c('div',{staticClass:"flex grow center"},[_c('div',{staticClass:"sc-chart"},[_c('e-charts',{ref:"chart",attrs:{"options":_vm.options,"init-options":_vm.initOptions,"autoresize":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }